import type { FieldPath, FieldValues } from 'react-hook-form';
import type { PhoneControllerProps } from './types';
import { usePhoneController } from './usePhoneController';

export function PhoneController<
	TFieldValues extends FieldValues,
	TName extends FieldPath<TFieldValues>,
	TTransformedValues = TFieldValues
>({
	clearErrors,
	control,
	invalidMessage,
	name,
	revalidateOn,
	render,
	setError
}: PhoneControllerProps<TFieldValues, TName, TTransformedValues>) {
	const phoneProps = usePhoneController({
		clearErrors,
		control,
		invalidMessage,
		name,
		revalidateOn,
		setError
	});

	return render(phoneProps);
}
